const config = require('./config.yaml');
const text = require('./text.yaml')[templateVars.lang];
const Sortable = require('sortablejs');
var path = require('path');
const emailJs = require('./emailForm.js');

class MyReport {
	constructor() {
		this.localforage = global.localforage.createInstance({
			name: `my-report_${templateVars.site}_${templateVars.lang}`
		});
	}

	// Добавить в мой отчёт текущую страницу, либо страницу с указанными параметрами.
	// Параметры задаются в виде объекта с полями {url, title, site, lang}
	add(pageOptions = {}) {
		const url = pageOptions.url || templateVars.siteUrl.path;
		const relativeUrl = pageOptions.pathTail || templateVars.siteUrl.pathTail;
		const pageTitle = templateVars.page.shortTitle ? templateVars.page.shortTitle : templateVars.page.title;

		return this.localforage.setItem(url, {
			type: 'my-report',
			site: pageOptions.site || templateVars.site,
			lang: pageOptions.lang || templateVars.lang,
			link: url,
			relativeLink: relativeUrl,
			title: pageOptions.title || pageTitle,
			tagTitle: pageOptions.title || templateVars.page.title
		});
	}

	// Получить список страниц моего отчёта
	getList() {
		return myReport.getLength()
			.then(dbLength => {
				var itemsArray = [];

				return this.localforage.iterate(function (value, key, iterationNumber) {
					itemsArray.push(value);
					if (iterationNumber === dbLength) {
						return itemsArray;
					}
				});
			});
	}

	getLength() {
		return this.localforage.length().then(value => {
			return value;
		});
	}

	//Очистить мой отчёт
	cleanMyReport() {
		return this.localforage.clear();
	}

	checkPageOnExist(pagePath) {
		return this.localforage.getItem(pagePath).then(value => {
			return value;
		});
	}

	removeItem(key) {
		return this.localforage.removeItem(key);
	}

	renderList() {
		//Вывод добавленных в мой отчет страниц
		if ($('#my-report').length > 0) {
			return myReport.getList()
				.then(result => {
					if (result) {
						$('#my-report-empty').hide();
						$('#my-report').show();

						result.forEach((item, i) => {
							const title = item.title,
								tagTitle = item.tagTitle,
								link = item.link,
								relativeLink = item.relativeLink;

							$('.my-report__list')
								.append(`<li class="my-report__item js-myreport-sortable" id="my-report-page" data-id="${link}">
										<div for="chbx${i}" class="checkbox my-report__checkbox">
											<input type="checkbox" id="chbx${i}" name="chbx${i}" class="my-report__input js-myreport-item">
											<label for="chbx${i}"></label>
										</div>
										<a href="${link}" data-relative-path="${relativeLink}" class="my-report__link" target="_blank" title="${tagTitle}">${title}</a>
									</li>`);
						});
					}
					disablePreloaderInItem($('#my-report-empty'));
				}).then(function () {
					sortList();
					myReportAllChange();
					$('.js-myreport-item').on('change', myReportItemsChange);
				});
		}
	}

	getActiveLinks() {
		let myReportPagesLinks = [];

		$('.js-myreport-sortable input:checked').parent('.my-report__checkbox').siblings('.my-report__link').each(function (i, elem) {
			myReportPagesLinks.push($(this).attr('data-relative-path'));
		});

		return myReportPagesLinks;
	}
}

const myReport = global.myReport = new MyReport();

// Очистка истории на страницах тестов
if (global.testComponentName && global.testComponentName.indexOf('my-report') < 0) {
	myReport.cleanMyReport();
}

export default myReport;

myReport.renderList();

//Сохранение и получение сортировки
function sortList() {
	var list = $('.js-myreport-list')[0];
	Sortable.create(list, {
		group: 'MyReportSort',
		filter: '.js-myreport-nosortable',
		draggable: '.js-myreport-sortable',
		store: {
			get: function (sortable) {
				var order = localStorage.getItem(sortable.options.group.name);
				return order ? order.split('|') : [];
			},

			set: function (sortable) {
				var order = sortable.toArray();
				localStorage.setItem(sortable.options.group.name, order.join('|'));
			}
		}
	});
}

//Обработка события изменения checkbox "Выделить все"
$('.js-myreport-all').on('change', myReportAllChange);

function myReportAllChange() {
	if ($('.js-myreport-all').prop('checked')) {
		$('.js-myreport-item').prop('checked', true);
		$('.js-myreport-btn').removeAttr('disabled');
	} else {
		$('.js-myreport-item').prop('checked', false);
		$('.js-myreport-btn').attr('disabled', 'disabled');
	}
}

//Обработка события изменения checkbox элемента моего отчета
function myReportItemsChange() {
	var $items = $('.js-myreport-item');
	var allChecked = true;
	$items.each(function () {
		if (!$(this).prop('checked')) {
			allChecked = false;
		}
	});
	if (allChecked) {
		$('.js-myreport-all').prop('checked', true);
	} else {
		$('.js-myreport-all').prop('checked', false);
	}
	if ($('.js-myreport-item:checked').length === 0) {
		$('.js-myreport-btn').attr('disabled', 'disabled');
	} else {
		$('.js-myreport-btn').removeAttr('disabled');
	}
}

//Обработка события нажатия на кнопу delete
$('.js-myreport-delete').on('click', myReportDelete);

function myReportDelete(e) {
	e.preventDefault();
	var $keys = $('.js-myreport-sortable .my-report__checkbox input:checked')
		.parent()
		.siblings('.my-report__link');

	function slideUpAfterRemove(key) {
		let $removeItem = $(`.js-myreport-sortable[data-id="${key}"]`);

		$removeItem
			.slideUp(300, function () {
				$removeItem.remove();
				if ($('.js-myreport-sortable:visible').length === 0) {
					$('#my-report').slideUp(300, function () {
						$('#my-report-empty').slideDown(300, () => {
							$('#my-report').triggerHandler('deleted');
						});
					});
				}
			});
	}

	$keys.each(function () {
		const key = $(this).attr('href');
		myReport.removeItem(key)
			.then(() => slideUpAfterRemove(key));
	});

	$('.js-myreport-btn').attr('disabled', 'disabled');
}

$('.js-myreport-all').prop('checked', true);

$('.js-myreport-save').on('click', function () {
	const query = myReport.getActiveLinks()
		.map(file => `myReportLinks[]=${encodeURIComponent(file)}`)
		.concat([
			`filename=files`,
			`siteType=${templateVars.site}`,
			`langType=${templateVars.lang}`,
		])
		.join('&');

	window.open(`/downloadPdf?${query}`, '_blank');
	return false;
});


$('.js-myreport-print').on('click', function () {
	const query = myReport.getActiveLinks()
		.map(file => `myReportLinks[]=${encodeURIComponent(file)}`)
		.concat([
			`filename=files`,
			`pageTitle=${encodeURIComponent(templateVars.page.title)}`,
			`siteType=${encodeURIComponent(templateVars.site)}`,
			`langType=${encodeURIComponent(templateVars.lang)}`
		])
		.join('&');

	let myWindow = window.open(path.join((templateVars.siteLangRootUrlRel) ? templateVars.siteLangRootUrlRel : '/', `printMyReport?${query}`), '_blank');
	myWindow.focus();
	myWindow.print();

	return false;
});



// WEBPACK FOOTER //
// ./temp/components/my-report/index.js